export var PAYMENT_METHODS = ["QUANTA", "USDC", "USDT", "BNB", "CAKE", "TWT"];
export var SETTLEMENT_MODEL_LABELS = {
    "highest-first-time-priority": "Highest price first, time priority on ties",
    "uniform-clearing-price": "Uniform clearing price for all winners",
    "first-come-first-served": "First come, first served (FCFS)",
};
